export const deliveryState: { [key: string]: any } = {
    product: 'PICK_UP',
    price: {
        net: 0,
        gross: 0,
        free: false,
    },
    deliveryDate: null,
    deliveryTime: null,
    deliveryType: null,
};
